export const paths = {
  companyPage: (companyId: number) =>
    `/main/html/searchrlp/company_id/${companyId}`,
  /**
   * @param keyword 検索キーワード, エスケープ不要
   */
  topics: (keyword: string) =>
    `/topics/keywords/${encodeURIComponent(keyword)}`,
  releaseType: (releaseTypeId: string) =>
    `/main/html/searchrlp/release_type_id/${releaseTypeId}/`,
  location: (prefId: string, cityId: string | null) =>
    `/main/html/searchcity/pref_id/${prefId}` +
    (cityId === null ? '' : `/city_id/${cityId}/`),
  locationCategory: (categoryId: number) =>
    `/main/html/searchloccate/location_cate_id/${categoryId}/`,
};
